import { StyledCell } from "./TableCell.styles";
import { TableCellProps } from "./TableCell.types";
import useViewport from "../../../../hooks/useViewport/useViewport";
import { getFontAndLineHeightArray } from "../../../typography/Typography/Typography.styles";
import BemIt, { addClass } from "@gtechdoodler/bem-it";

const TableCell: React.FC<TableCellProps> = ({
	children,
	variant = "data",
	className,
	...props
}) => {
	const block = new BemIt("TableCell");

	const vp = useViewport();
	const fontAttributes = getFontAndLineHeightArray("body-large", vp);
	const fontAttributesHead = getFontAndLineHeightArray("h6", vp);

	return (
		<StyledCell
			className={addClass(className).after(block)}
			fontAttributes={variant === "head" ? fontAttributesHead : fontAttributes}
			as={variant === "head" ? "th" : "td"}
			{...props}
		>
			{children}
		</StyledCell>
	);
};

export default TableCell;
